export const LAST_SAVED_ON_WEB = 'web'
export const LAST_SAVED_ON_IOS = 'ios'
export const LAST_SAVED_ON_ANDROID = 'android'

export const FEATURE_WALLART = 'wallArt'
export const FEATURE_ERASER = 'erased'
export const FEATURE_STACKABLES = 'stackable'
export const FEATURE_COMBINABLES = 'combinable'
export const FEATURE_WALLPAINT = 'wallPaint'

export const FEATURE_VERSIONS = {
    [FEATURE_WALLART]: 1,
    [FEATURE_ERASER]: 1,
    [FEATURE_STACKABLES]: 1,
    [FEATURE_COMBINABLES]: 1,
    [FEATURE_WALLPAINT]: 1,
}
